import { Reducer } from 'redux';
import { DashboardActionTypes } from '../constants/actionTypes';
import { DashboardActions } from '../actions/dashboardAction';

export interface IDashboardState {
  readonly dashboardData: string;
}

// Define the initial state
const initialDashboardState: IDashboardState = {
  dashboardData: '',
};

export const dashboardReducer: Reducer<IDashboardState, DashboardActions> = (
  state = initialDashboardState,
  action : DashboardActions,
) => {
  switch (action.type) {
    // TODO : Change below cases, as currently just kept placeholder
    case DashboardActionTypes.FETCH_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.dashboardData,
      };
    default:
      return state;
  }
};
